module.exports = __webpack_public_path__ + "img/ColoredSpace8.ce7c4ca7.svg";